"use strict";require("../../../runtime/vdom/marko-namespace");
var registry = require("@internal/components-registry");

exports.getComponentForEl =
require("@internal/components-util").U_;
exports.init = registry.V_;
exports.register = function (id, component) {
  registry.r(id, function () {
    return component;
  });
};